module.exports = __webpack_public_path__ + "img/custom-05.80d1ed57.jpg";